import { useTranslation } from 'react-i18next';
import { Badge, type Tone } from '../list/expense-labels';
import type { ReportStatus } from './types';

const TONE: Record<ReportStatus, Tone> = {
  draft: 'neutral',
  submitted: 'warning',
  more_info_requested: 'warning',
  accepted: 'success',
  refused: 'error',
  partially_reimbursed: 'info',
  reimbursed: 'success',
  repayment_requested: 'warning',
  repaid: 'success',
};

/**
 * The report's state (spec §1.1). The stage of an approval shows inside the badge when the
 * caller knows it: the list's rows do not carry it, the report's page does.
 */
export function ReportStatusBadge({
  status,
  stage,
}: {
  readonly status: ReportStatus;
  readonly stage?: number | null | undefined;
}) {
  const { t } = useTranslation('expenses');
  const staged = status === 'submitted' && (stage === 1 || stage === 2);
  const label = staged ? t(`reports.status.submittedStage${stage}`) : t(`reports.status.${status}`);
  return <Badge tone={TONE[status]}>{label}</Badge>;
}
